/* eslint-disable no-new */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line
// @ts-ignore
import PhotoSwipe from 'photoswipe/lightbox'
import 'photoswipe/style.css'
import { useEffect } from 'react'
import ObjectPosition from './lightboxObjectPosition'

type Options = {
  containerId: string
}

const useSingleImageViewer = ({ containerId }: Options) => {
  useEffect(() => {
    if (!document.getElementById(containerId)) {
      return
    }

    const lightbox = new PhotoSwipe({
      gallery: `#${containerId}`,
      bgOpacity: 0.9,
      pswpModule: () => import('photoswipe'),
    })
    lightbox.addFilter('domItemData', (itemData: any, element: any) => {
      itemData.src = element.dataset.src
      itemData.msrc = element.dataset.src
      itemData.w = element.dataset.width || element.firstChild.naturalWidth
      itemData.h = element.dataset.height || element.firstChild.naturalHeight
      return itemData
    })

    new ObjectPosition(lightbox)
    lightbox.init()

    return () => {
      lightbox.destroy()
    }
  }, [containerId])
}

export default useSingleImageViewer
